//
// The systems a document is saved to. Mirrored by numeric value from the API
// (REDLAB.SkillControl.Contracts/Primitives/DocumentProvider.cs); 1, 4 and 5 are ISOPlanner's and unused here.
//
export enum DocumentProviderType {
  SharePoint = 0,
  GoogleDrive = 2,
  Nextcloud = 3,
}

// The reserved connection id of SharePoint and OneDrive: the synthetic entry of GET documentconnections, reached with
// the signed-in user's own Graph token. It has no grant to start and cannot be edited.
export const sharePointConnectionId = 0;

// The reserved connection id of the SharePoint delivery permission (phase 61): the grant a scheduled run saves to
// SharePoint and OneDrive with. Never a connection of the list; only granted (its grant/start) and listed as a grant.
export const sharePointDeliveryConnectionId = -1;

// What a provider can do; the client gates every action on these values
export class DocumentProviderCapabilities {
  browse: boolean;

  upload: boolean;

  createFolder: boolean;

  webLink: boolean;

  // the provider needs a DocumentConnection row (false for SharePoint)
  requiresConnection: boolean;

  // a connection can act as the signed-in Workspace user through REDLAB's service account (Google Drive)
  supportsDomainDelegation: boolean;

  // a connection can let each user grant their own account once (Nextcloud)
  supportsUserDelegation: boolean;

  constructor() {
    this.browse = false;
    this.upload = false;
    this.createFolder = false;
    this.webLink = false;
    this.requiresConnection = false;
    this.supportsDomainDelegation = false;
    this.supportsUserDelegation = false;
  }
}

export class DocumentProviderDescriptor {
  providerType: DocumentProviderType;

  name: string;

  capabilities: DocumentProviderCapabilities;

  constructor() {
    this.providerType = DocumentProviderType.SharePoint;
    this.name = '';
    this.capabilities = new DocumentProviderCapabilities();
  }
}

// Product names, the same in every language
export function getDocumentProviderName(type: DocumentProviderType): string {
  switch (type) {
    case DocumentProviderType.SharePoint:
      return 'SharePoint';
    case DocumentProviderType.GoogleDrive:
      return 'Google Drive';
    case DocumentProviderType.Nextcloud:
      return 'Nextcloud';
    default:
      return '';
  }
}
